<script setup>
import { ToastProvider, Toaster } from '@/components/ui/toast'
import ChatBot from '@/components/custom/ChatBot';

const cosmo = useCosmo();
const chatbotOpen = computed(() => cosmo.isOpen);
const requestUrl = useRequestURL();

useHead({
  htmlAttrs: {
    lang: 'en'
  },
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/images/spotsurferLogo.png'
    },
    {
      key: 'canonical',
      rel: 'canonical',
      href: `${requestUrl.origin}${requestUrl.pathname}`,
    }
  ]
});
</script>

<template>
  <NuxtLoadingIndicator />
  <ChatBot />
  <div
    class="transition-all duration-300 ease-in-out"
    :style="{
      width: chatbotOpen ? 'calc(100vw - 400px)' : '100vw'
    }"
  >
  <NuxtLayout>
    <NuxtPage />
    <ToastProvider>
      <div class="z-999999" :class="[chatbotOpen ? 'chat-open' : '']">
        <Toaster />
      </div>
    </ToastProvider>
  </NuxtLayout>
  </div>
</template>

<style>
.chat-open ol {
  left: 0 !important;
}

@media (max-width: 767px) {
  input, select, textarea {
    font-size: 16px !important;
  }
  .text-sm {
    font-size: 16px !important;
  }
}
</style>
